import requests from "./httpService";

const HourRentalBasicRateServices = {
  getAllHourRentalBasicRate: async (body) => {
    return requests.get(`/hourRentalBasicRate/`);
  },

  addHourRentalBasicRate: async (body) => {
    return requests.post(`/hourRentalBasicRate/add`, body);
  },
  getHourRentalBasicRateById: async (id) => {

    return requests.get(`/hourRentalBasicRate/${id}`);
  },

  updateHourRentalBasicRate: async (id, body) => {
    return requests.put(`/hourRentalBasicRate/update/${id}`, body);
  },

  deleteHourRentalBasicRate: async (id) => {
    return requests.delete(`/hourRentalBasicRate/delete/${id}`);
  },

  updateHourRentalStatus: async (id, body) => {
    return requests.post(`/hourRentalBasicRate/update-status/${id}`, body);
  }
};

export default HourRentalBasicRateServices;
